import { render, staticRenderFns } from "./ToastError.vue?vue&type=template&id=0fefbec2&scoped=true&"
import script from "./ToastError.vue?vue&type=script&lang=js&"
export * from "./ToastError.vue?vue&type=script&lang=js&"
import style0 from "./ToastError.vue?vue&type=style&index=0&id=0fefbec2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fefbec2",
  null
  
)

export default component.exports